import CardPaymentInfo from './CardPaymentInfoContainer';

export default CardPaymentInfo;
